export default __webpack_public_path__ + "static/media/browser.1e522e7e.png";